import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import Avatar from '../shared/avatar.component';
import setToast from '../../helpers/toaster.helper';
import * as selector from '../../selectors/selectors';
import { UserService } from '../../services/UserService';
import { DisplayMediaIcon } from './display-media.component';
import { ToasterType } from '../shared/toaster/toaster.model';
import { StatusRenderer } from '../shared/grid/statusRenderer';
import { UtilityService } from '../../services/UtilityService';
import ButtonComponent from '../shared/button/button.component';
import { buttonLabels, ToasterTexts } from '../shared/constants';
import AddAccessListTextComponent from './add-access-list.component';
import { SecureFileService } from '../../services/SecureFileService';
import AnimateLoader from "../shared/loaders/animate-loader.component";
import ProfileTextboxLoader from "../shared/loaders/textbox-loader.json";
import { CancelIcon, ManageAccessEditIcon, SecureFileDownloadIcon, SecureFileEditIcon } from '../../icon';
import { FaceAuthenticationModel, FaceRegistrationInviteLinkStatus, SecureFileInfoModel, SecureFileStatusModel, mapToSecureFileInfoModel } from '../../models/secure-file';
import { Autocomplete, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, Grid, TextField, Tooltip } from '@mui/material';
import { LoadSecureFiles } from '../../actions';
import { useDispatch } from 'react-redux';
import { PlanMetrics } from '../../models/plan-metrics.model'
import { HmacSignatureUtilities } from '../../services/hmac-encryption-decryption';

interface Props {
    Id: string;
    Show: boolean;
    FileName: string;
    OnClose: (openManageAccess?: boolean) => void
}

const ViewSecureFile = (props: Props) => {
    const dispatch = useDispatch();
    const FaceAuthenticationFiles: FaceAuthenticationModel[] = useSelector(selector.faceAuthenticatonFiles);
    const PlanMetrics: PlanMetrics = useSelector(selector.planMetrics)

    const [showAddContact, setShowAddContact] = useState<boolean>(false)
    const [error, setErrors] = useState({ Emailaccess: "", Faceaccess: "" })
    const [fileDetailData, setFileDetailData] = useState<SecureFileInfoModel>()
    const [imMutablefileDetailData, setImMutableFileDetailData] = useState<SecureFileInfoModel>()
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const fileDownload = (fileName: string) => {
        let data = {
            "file_name": fileName,
            "user_id": UserService.getCurrentUserId(),
            "id": props.Id
        }
        SecureFileService.downloadSecureFile(data).then((response) => {
            // if (HmacSignatureUtilities.verifySignature(response.data, response.headers["falkonsignature"])) {
            const url = URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            link.click();
            setToast(ToasterTexts.FILE_DOWNLOAD_SUCCESS, ToasterType.SUCCESS)
            // }
            // else{
            //     setToast("file corrupted,not downloadable",ToasterType.DANGER)
            // }
        })
    }

    useEffect(() => {
        let data = {
            "id": props.Id,
            "user_id": UserService.getCurrentUserId(),
            "file_name": props.FileName
        }
        SecureFileService.getSelectedFile(data).then((res) => {
            if (HmacSignatureUtilities.verifySignature(res.data, res.headers["falkonsignature"])) {
                setFileDetailData(mapToSecureFileInfoModel(res.data))
                setImMutableFileDetailData(mapToSecureFileInfoModel(res.data))
            }
            else {
                setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
            }
        }).catch((err) => {
            setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
        })
    }, [])

    const showAddAccessContact = () => {
        setFileDetailData(imMutablefileDetailData)
        setShowAddContact(!showAddContact)
    }

    const addAccessListHandle = (list) => {
        setFileDetailData({ ...fileDetailData, Access: list })
    }

    const addAccess = () => {
        setIsLoading(true)
        let data = {
            id: props.Id,
            file_name: props.FileName,
            user_id: UserService.getCurrentUserId(),
            access_list: fileDetailData?.Access?.filter((x) => UtilityService.isValidEmail(x)),
            face_access_list: fileDetailData?.FaceAccess,
        }
        SecureFileService.addFillAccess(data)
            .then(() => {
                setShowAddContact(false)
                setToast(ToasterTexts.EDIT_ACCESS_SUCCESS_MESSAGE, ToasterType.SUCCESS)
                LoadSecureFiles(dispatch, { "user_id": UserService.getCurrentUserId() })
                props.OnClose()
                setIsLoading(false)
            })
            .catch((err) => {
                setToast(err.response.data.error, ToasterType.DANGER);
                setIsLoading(false)
            })
    }

    const handleSelectionChange = (event, newValue) => {
        setFileDetailData({ ...fileDetailData, FaceAccess: newValue.map(x => x.ContactPhoneNumber) })
    }

    return (
        <div>
            <Dialog
                maxWidth="sm"
                fullWidth={true}
                BackdropProps={{ style: { backgroundColor: "transparent" } }}
                open={props.Show}
                onClose={() => props.OnClose()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                classes={{ paper: `br-2 w-p-30 dialogue-shadow px-2 ` }}
                disableEscapeKeyDown
            >
                <DialogTitle className='px-1 color-secure-file-dialog-title h3-semibold'>
                    <div className='d-flex justify-between align-center'>
                        <span> Manage Access</span>
                        <CancelIcon className="c-pointer" onClick={() => props.OnClose()} />
                    </div>
                </DialogTitle>
                <div className={`d-flex flex-direction py-1`}>
                    <DialogContent className='pb-2 pt-0 px-1'>
                        {
                            !fileDetailData ? <AnimateLoader LoaderAnimation={ProfileTextboxLoader} className="h-3 w-10 mt-1" /> :
                                <div className='d-flex'>
                                    <div className='d-flex w-p-96 align-start color-toaster-font bg-color-template-background br-1 h5-regular c-pointer' >
                                        <div className="d-flex align-start w-p-94 p-1">
                                            {fileDetailData.FileName}
                                        </div>
                                        <div className="d-flex align-end w-p-6 mr-1 mt-1">
                                            <DisplayMediaIcon FileName={fileDetailData.FileName} />
                                        </div>
                                    </div>
                                    <div className='align-end p-1 w-p-4'>
                                        <SecureFileDownloadIcon className="ml-1 c-pointer" onClick={() => fileDownload(fileDetailData.FileName)} />
                                    </div>
                                </div>
                        }
                        <Grid container className='w-p-100 py-2'>
                            <Grid item xl={7} md={7} className='h6-regular'>
                                <Grid container>
                                    <Grid item xl={5} md={5} className='color-secure-file-viewDetails-dialog-date'>
                                        Upload Date
                                    </Grid>
                                    <Grid item xl={7} md={7} className='color-primary-accent'>
                                        {!fileDetailData ?
                                            <AnimateLoader LoaderAnimation={ProfileTextboxLoader} className="h-3 w-10 mt-1" /> :
                                            <span>
                                                {UtilityService.convertDateToDay(fileDetailData.UploadedDate)}
                                            </span>
                                        }
                                    </Grid>
                                </Grid>
                                <Grid container className='mt-1'>
                                    <Grid item xl={5} md={5} className='color-secure-file-viewDetails-dialog-date'>
                                        Expiry Date
                                    </Grid>
                                    <Grid item xl={7} md={7} className='color-primary-accent'>
                                        {!fileDetailData ? <AnimateLoader LoaderAnimation={ProfileTextboxLoader} className="h-3 w-10 mt-1" /> : UtilityService.convertDateToDay(fileDetailData.ExpiryDate)}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xl={5} md={5} className='color-primary-accent h5-medium'>
                                <Grid container>
                                    <Grid item xl={5} md={5} className='color-secure-file-viewDetails-dialog-date'>
                                        Size
                                    </Grid>
                                    <Grid item xl={7} md={7} className='color-primary-accent'>
                                        {!fileDetailData ? <AnimateLoader LoaderAnimation={ProfileTextboxLoader} className="h-3 w-10 mt-1" /> : fileDetailData.FileSize + " MB"}
                                    </Grid>
                                </Grid>
                                <Grid container className='mt-1'>
                                    <Grid item xl={5} md={5} className='color-secure-file-viewDetails-dialog-date'>
                                        Status
                                    </Grid>
                                    <Grid item xl={7} md={7} className='color-primary-accent'>
                                        <StatusRenderer Label={fileDetailData?.FileStatus} Variant={fileDetailData?.FileStatus === SecureFileStatusModel.Active ? 'active' : 'danger'} Id={''} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container className='mt-1 h5-medium'>
                                <Grid item className='color-secure-file-viewDetails-dialog-date'>
                                    Document Permission
                                </Grid>
                                <Grid item className='color-primary-accent ml-2'>
                                    {fileDetailData?.IsReadOnly ? "Read Only" : "Download Only"}
                                </Grid>
                            </Grid>
                        </Grid>
                        {
                            !fileDetailData ?
                                <AnimateLoader LoaderAnimation={ProfileTextboxLoader} className="h-3 w-10 mt-1" /> :
                                <div>
                                    <div className='flex-direction pt-2 align-center color-primary-accent py-1 c-pointer' >
                                        <div className='d-flex justify-between align-center'>
                                            <span className='h5-semibold'>Who has link access:</span>
                                            <Tooltip title={"Edit Access"} placement='bottom' >
                                                <span onClick={() => showAddAccessContact()} className='c-pointer'>{<ManageAccessEditIcon />}
                                                </span>
                                            </Tooltip>
                                        </div>
                                        {!showAddContact && <div className='d-flex mt-1'>
                                            {
                                                fileDetailData.Access?.map((mail, index) =>
                                                    <div className='d-flex'>
                                                        <Tooltip title={mail} placement='top' className='mr-2'>
                                                            <span className='c-pointer'>
                                                                <Avatar Name={mail} Size={30} />
                                                            </span>
                                                        </Tooltip>
                                                    </div>
                                                )
                                            }
                                        </div>}
                                    </div>
                                    {showAddContact &&
                                        <div className='pt-1'>
                                            <AddAccessListTextComponent
                                                PlaceHolder={"Add People:"}
                                                AddAccessListHandel={addAccessListHandle}
                                                Accesslist={fileDetailData?.Access}
                                            />
                                            <FormHelperText className={`h5 color-primary-danger t-align-right`}>
                                                {error.Emailaccess}
                                            </FormHelperText>
                                        </div>
                                    }
                                    {
                                        PlanMetrics?.HasAccessToFaceVault && <div className='flex-direction align-center color-primary-accent pt-2 py-1 c-pointer'>
                                            <span className='mr-2 h5-semibold'>Who has Face authentication access:</span>
                                            {!showAddContact && <div className='d-flex mt-1'>
                                                <div className="h3-regular">
                                                    {fileDetailData.FaceAccess?.length > 0 ? (
                                                        fileDetailData.FaceAccess.map((phoneNumber, index) => (
                                                            <Chip
                                                                key={index}
                                                                label={phoneNumber}
                                                                variant="outlined"
                                                                color="primary"
                                                                style={{ margin: '5px' }}
                                                            />
                                                        ))
                                                    ) : (<div></div>)}
                                                </div>
                                            </div>}
                                        </div>
                                    }
                                    {PlanMetrics?.HasAccessToFaceVault && showAddContact &&
                                        <div className='d-flex align-end justify-between'>
                                            <div className='d-flex w-p-90'>
                                                <Autocomplete
                                                    multiple
                                                    freeSolo={false}
                                                    fullWidth
                                                    disableClearable
                                                    className="field-border"
                                                    options={FaceAuthenticationFiles.filter(x => x.Status === FaceRegistrationInviteLinkStatus.Registered)}
                                                    getOptionLabel={(option) => `${option.Name} ${option.ContactPhoneNumber || ""}`}
                                                    componentsProps={{
                                                        popupIndicator: { style: { display: 'none' } },
                                                    }}
                                                    value={FaceAuthenticationFiles.filter(x => fileDetailData?.FaceAccess.includes(x.ContactPhoneNumber))}
                                                    onChange={handleSelectionChange}
                                                    renderOption={(props, option) => (
                                                        <li {...props} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                            <div className='ml-2 h4-regular'>{option.Name}</div>
                                                            <div className='mr-2 h4-regular'>{option.ContactPhoneNumber}</div>
                                                        </li>
                                                    )}
                                                    renderTags={(value, getTagProps) => {
                                                        return value.map((option, index) => (
                                                            <Chip
                                                                classes={{ colorPrimary: "custom-color-chip-1" }}
                                                                key={index}
                                                                label={!!option.Name?.trim() ? option.Name : option.ContactPhoneNumber}
                                                                {...getTagProps({ index })}
                                                            />
                                                        ));
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="standard"
                                                            placeholder={FaceAuthenticationFiles.filter((x) => fileDetailData?.FaceAccess.includes(x.ContactPhoneNumber)).length > 0 ? "" : "Add Face authentication access:"}
                                                        />
                                                    )}
                                                />
                                            </div>
                                            <SecureFileEditIcon />
                                        </div>
                                    }
                                </div>
                        }
                    </DialogContent>
                </div>
                <DialogActions className='pb-2'>
                    <ButtonComponent ButtonLabel={buttonLabels.CANCEL} Variant={"secondary-btn-small"} ClassName='mr-1' OnClick={() => props.OnClose()} />
                    <ButtonComponent
                        ButtonLabel={buttonLabels.SAVE}
                        OnClick={addAccess}
                        Variant={showAddContact && (!fileDetailData?.Access?.some((x) => !UtilityService.isValidEmail(x)) && fileDetailData?.FaceAccess?.length >= 0)
                            ? "primary-btn-small"
                            : "disabled-btn-small"
                        }
                        Loading={isLoading}
                    />
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default ViewSecureFile